<template>
  <el-form
    v-loading.fullscreen.lock="loading"
    :class="['send-message-wrapper', { 'has-small-input': smallInput }]"
    :model="form"
    @submit.native.prevent="onSubmit"
  >
    <el-form-item :error="error('content')">
      <slot
        name="beforeFields"
        :form="form"
        :error="error"
        :change="change"
      />
      <div
        v-if="isMobile"
        class="btn-send-custom"
      >
        <el-input
          v-model="form.content"
          @change="change('content')"
        />
        <div
          class="icon-wrapper"
          @click="onSubmit"
        >
          <i class="icon-send" />
        </div>
      </div>
      <div
        v-else
        class="btn-send-custom"
      >
        <el-input
          v-model="form.content"
          type="textarea"
          :autosize="{ minRows: smallInput ? 1 : 2 }"
          @change="change('content')"
        />
        <div
          v-if="smallInput"
          class="icon-wrapper"
          @click="onSubmit"
        >
          <i class="icon-send" />
        </div>
      </div>
      <!--<el-input v-else v-model="form.content" type="textarea" :rows="4" @change="change('content')" :placeholder="$t('write-message.content.placeholder')"></el-input>-->
      <slot
        name="afterFields"
        :form="form"
        :error="error"
        :change="change"
      />
    </el-form-item>
    <el-button
      v-if="!smallInput"
      class="center-self main-large"
      @click="onSubmit"
    >
      {{ $t('write-message.send.text') }}
    </el-button>
  </el-form>
</template>
<script>
  import FormPage from '@/components/Core/ResourcePage';
  import { mapState } from 'vuex';

  export default {
    extends: FormPage,
    props: {
      appendData: {
        type: Object,
        default: () => ({}),
      },
      smallInput: {
        type: Boolean,
        default: false,
      },
      lastPrice: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        resource: 'messages',
        form: {
          content: '',
        },
      };
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        locale: state => state.locale,
      }),
    },
    watch: {
      lastPrice: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.sendMsg(newVal);
          }
        },
      },
    },
    methods: {
      onRouteLoaded() {},
      sendMsg(msg) {
        this.form.content = msg;
        this.onSubmit();
      },
      onSubmit() {
        this.provider.add({
          ...this.form,
          ...this.appendData,
        })
          .then(() => {
            this.loading = false;
            this.form = {};
            this.$emit('done');
          })
          .catch(({ response }) => {
            if (response.data.errors.user_id) {
              this.$message({ type: 'error',
                showClose: true,
                message: ` ${this.$t('ad.write-message-disabled.text')}`,
              });
            }
            this.loading = false;
            this.onFormError(response);
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Ads/SendMessage.vue